export default __webpack_public_path__ + "static/media/icon_dashboard.b200082a.svg";